import {
    CANNED_QUESTION_TAX_INVOICE,
    PARENT_FIELD_MULTIPLIER,
} from '../constants';

/**
 * Reorder subquestions (choice questions) just after the parent ones (they render according to the list order)
 */
export const orderQuestions = (questionsList) => {
    // To properly assign incrementing indexes to sub-questions
    let lastParentQuestionName = null;
    let subQuestionIndex = 0;
    let orderedQuestionsList = [...questionsList];

    // This hack moves the N-is_business question to the first position
    const taxInvoiceQuestion = orderedQuestionsList.find(
        (question) => question.name === CANNED_QUESTION_TAX_INVOICE,
    );

    if (taxInvoiceQuestion) {
        orderedQuestionsList = [
            taxInvoiceQuestion,
            ...orderedQuestionsList.filter(
                (question) => question !== taxInvoiceQuestion,
            ),
        ];
    }

    // Transform the ordered list into an object list, and add index for all parent questions
    // (leaving 99 slots for children questions)
    const partiallyIndexedQuestions = orderedQuestionsList.map(
        (question, originalIndex) => ({
            index: question.renderConditionTrigger
                ? 0
                : (originalIndex + 1) * PARENT_FIELD_MULTIPLIER,
            value: question,
        }),
    );

    // Add index to subquestions by taking parent question index and incrementing it
    const fullyIndexedQuestions = partiallyIndexedQuestions.map((element) => {
        const elementCopy = { ...element };

        if (element.index === 0) {
            if (
                element.value.renderConditionTrigger.parentQuestionId !==
                lastParentQuestionName
            ) {
                subQuestionIndex = 0;
                lastParentQuestionName =
                    element.value.renderConditionTrigger.parentQuestionId;
            }
            const parentQuestion = partiallyIndexedQuestions.find(
                (needle) =>
                    needle.value.name ===
                    element.value.renderConditionTrigger.parentQuestionId,
            );

            if (parentQuestion) {
                elementCopy.index = parentQuestion.index + ++subQuestionIndex;
            }
        }
        return elementCopy;
    });

    // Sort by index...
    const orderedIndexedQuestions = fullyIndexedQuestions.sort(
        (first, second) => first.index - second.index,
    );

    // And go back to a simple ordered list, now with subquestions located just after their parent question
    return orderedIndexedQuestions.map((element) => element.value);
};
